
(function () {
	document.addEventListener("DOMContentLoaded", () => {

		if (!document.body.classList.contains("single-vg_gym")) return;

		const currentGymName = document.querySelector('article[data-gym-label]')?.getAttribute('data-gym-label');

		document.addEventListener("click", (event) => {

			const item = event.target;

			if (!item) return;

			if (handleTrainCtaClick(item)) return;

			if (handleSubscriptionCtaClick(item)) return;

			if (handleDayPassCtaClick(item)) return;

			if (handleClasesCtaClick(item)) return;

			if (handleViewNearestGyms(item)) return;

			if (handleViewMoreGyms(item)) return;
		});

		document.addEventListener("gtmLeadFormSubmit", async (event) => {
			if (!event.detail) return;

			const gtmData = {
				event_category: 'newsletter',
				event_detail: event.detail.success ? 'envio_ok' : 'envio_ko',
				event_label: event.detail.success ? 'envio_ok' : event.detail.error,
				club_name: VgGtm.formatGtmLabel(event.detail.gtm_data?.club_name),
				club_region: VgGtm.formatGtmLabel(event.detail.gtm_data?.club_region),
			}

			if (event.detail.success) {
				gtmData.email_hashed = event.detail.gtm_data?.email_hashed;
				gtmData.phone_hashed = event.detail.gtm_data?.phone_hashed;
			}

			VgGtm.pushRegisterEventToDataLayer(
				'form_interaction',
				{},
				gtmData
			);
		});

		function handleTrainCtaClick(item) {
			const trainCta = item.closest(".vg-gym-header__train");
			if (!trainCta) return false;

			VgGtm.pushRegisterEventToDataLayer(
				'cta_click',
				{},
				{
					event_category: 'ficha_gimnasio',
					event_detail: 'cta',
					event_label: 'apuntate',
					club_name: VgGtm.formatGtmLabel(currentGymName),
				}
			);

			return true;
		}

		function handleSubscriptionCtaClick(item) {
			const subscriptionLink = item.closest(".vg-product__link");
			if (!subscriptionLink) return false;

			VgGtm.pushRegisterEventToDataLayer(
				'cta_click',
				{},
				{
					event_category: 'ficha_gimnasio',
					event_detail: 'cuotas',
					event_label: VgGtm.formatGtmLabel(subscriptionLink.dataset.label),
					club_name: VgGtm.formatGtmLabel(currentGymName),
				}
			);

			return true;
		}

		function handleDayPassCtaClick(item) {
			const dayPassLink = item.closest(".vg-product__link--daypass");
			if (!dayPassLink) return false;

			VgGtm.pushRegisterEventToDataLayer(
				'cta_click',
				{},
				{
					event_category: 'ficha_gimnasio',
					event_detail: 'pase_de_dia',
					event_label: 'compra_' + VgGtm.formatGtmLabel(dayPassLink.dataset.label),
					club_name: VgGtm.formatGtmLabel(currentGymName),
				}
			);
			return true;
		}

		function handleClasesCtaClick(item) {
			const clasesLink = item.closest(".vg-facilities__clases-download-link");
			if (!clasesLink) return false;

			VgGtm.pushRegisterEventToDataLayer(
				'click',
				{},
				{
					event_category: 'descarga',
					event_detail: 'descargar_horario_completo',
					event_label: 'descargar_horario_completo',
					club_name: VgGtm.formatGtmLabel(currentGymName),
				}
			);
			return true;
		}

		function handleViewNearestGyms(item) {
			const gymLink = item.closest('.vg-nearest-gyms__item a');
			if (!gymLink) return false;

			const gymItem = gymLink.closest('.vg-nearest-gyms__item');
			const gymTitle = gymItem.querySelector('.vg-nearest-gyms__item-title');

			VgGtm.pushRegisterEventToDataLayer(
				'click',
				{},
				{
					event_category: 'gimnasios_cercanos',
					event_detail: 'ver_gimnasio',
					event_label: VgGtm.formatGtmLabel(gymTitle.textContent),
					club_name: VgGtm.formatGtmLabel(currentGymName),
				}
			);

			return true;
		}

		function handleViewMoreGyms(item) {
			const viewMoreLink = item.closest('.vg-nearest-gyms__cta a');
			if (!viewMoreLink) return false;

			VgGtm.pushRegisterEventToDataLayer(
				'click',
				{},
				{
					event_category: 'gimnasios_cercanos',
					event_detail: 'ver_mas_gimnasios_cercanos',
					event_label: 'ver_mas_gimnasios_cercanos',
					club_name: VgGtm.formatGtmLabel(currentGymName),
				}
			);

			return true;
		}

	});
})();
